// Integration types whose sites do NOT read from the connector settings file.
// For these, the site's "Last Synchronized" timestamp (and the "Synced" status
// derived from the same deployment) is meaningless, so it is hidden from site
// views. AI Link, Sentinel Verifier and Clips-based sites all fall into this
// group.
export const NON_SETTINGS_FILE_INTEGRATION_TYPES: string[] = [
  "ailink",
  "sentinel-verifier",
  "clips",
];

// Returns true when a site of the given integration type reads from the
// settings file (and therefore has a meaningful last-synchronized time).
export const readsSettingsFile = (
  integrationTypeName: string | null | undefined
): boolean =>
  !NON_SETTINGS_FILE_INTEGRATION_TYPES.includes(integrationTypeName ?? "");
